// Package imports:
import React from 'react';
// Component imports:
import KaupsamningarComp from '../../components/Kaupsamningar/Kaupsamningar';
import Entrypoint from '../Entrypoint';

const PurchaseAgreements: React.FC = () => {
    return (
        <Entrypoint>
            <KaupsamningarComp />
        </Entrypoint>
    )
}

export default PurchaseAgreements;